import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/core/auth';
import { queryClient } from '@/core/data-fetching/queryClient';
import { PlatformBrandingProvider } from '@/core/platform-branding';
import { AppRouter } from '@/app/router';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <PlatformBrandingProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster richColors position="top-right" />
          {import.meta.env.DEV && (
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
          )}
        </AuthProvider>
      </PlatformBrandingProvider>
    </QueryClientProvider>
  );
}
